<template>
  <form @submit.prevent="onSubmit">
    <div class="modal-body">
      <FormGroup v-if="!isEdit">
        <h5 class="name">ชื่อ</h5>
        <input type="text"
          class="form-control"
          :class="{'is-invalid': error.title}"
          @blur="validateTitle"
          v-model="title"
          v-if="!isEdit"/>
        <div class="invalid-feedback">
          {{error.title}}
        </div>
      </FormGroup>
      <FormGroup>
        <h5 class="name">ลิงค์</h5>
        <input
          type="url"
          class="form-control"
          :class="{'is-invalid': error.link}"
          @blur="validateLink"
          v-model="link" />
        <div class="invalid-feedback">
          {{error.link}}
        </div>
      </FormGroup>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-outline-secondary mr-auto"
        @click="onClickBack">
          <i class="fa fa-chevron-left mr-2" /> ย้อนกลับ
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        :disabled='!isValid'>
        อัปโหลด
      </button>
    </div>
  </form>
</template>

<script>
import FormGroup from '@/components/FormGroup.vue';

export default {
  props: ['onClickUpload', 'onClickBack', 'isEdit'],
  data() {
    return {
      title: '',
      link: '',
      error: {
        title: '',
        link: '',
      },
    };
  },
  components: {
    FormGroup,
  },
  computed: {
    isValid() {
      if ((this.title === '' && !this.isEdit) || this.link === '') return false;
      return !this.error.title && !this.error.link;
    },
  },
  methods: {
    validateTitle() {
      this.error.title = '';
      if (!this.title) {
        this.error.title = 'กรุณาระบุชื่อของวิดีโอ';
      }
    },
    validateLink() {
      this.error.link = '';
      if (!this.link || !this.link.includes('vod')) {
        this.error.link = 'กรุณาใส่ลิงค์วิดีโอ vod';
      }
    },
    getVodId() {
      const array = this.link.split('/');
      return array[4];
    },
    onSubmit() {
      const data = {
        title: this.title,
        type: 'vod',
        media: {
          sourceKey: this.getVodId(),
          type: 'qoder',
          sourceUrl: this.link,
        },
      };
      this.onClickUpload(data);
    },
  },
};
</script>
